//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Spine from '@/components/Spine';

export const CharacterAnimation = {
  WAITING: 'waiting',
  ROTATION: 'rotation',
  FINISH: 'finish'
};

import { GameStatus, Multiplier, Game } from '../wheel.entity';

export default {
  name: 'WheelHomeGameCharacter',
  components: {
    Spine
  },
  props: {
    status: {
      type: Number,
      default: GameStatus.ENDED
    },
    startAt: {
      type: String,
      default: ''
    },
    // 假设从父级或 Vuex / 全局注入的配置项
    assetsDir: {
      type: String,
      default: '/assets/'
    },
    disableAnimations: {
      type: Boolean,
      default: false
    },
    timeDiff: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      animationName: CharacterAnimation.WAITING,
      loop: true,
      CharacterAnimation,
      // 内部用于记录当前等待完成的动画回调
      animationResolve: null
    };
  },
  computed: {
    staticAnimationName() {
      return this.disableAnimations ? CharacterAnimation.WAITING : null;
    }
  },
  watch: {
    status: {
      immediate: true,
      handler(newStatus) {
        this.handleStatusChange(newStatus);
      }
    }
  },
  methods: {
    handleStatusChange(status) {
      // 重置之前的动画监听状态
      this.clearPendingAnimation();

      if (status === GameStatus.CREATED) {
        this.setAnimation(CharacterAnimation.WAITING);
      } else if (status === GameStatus.STARTED) {
        const timePassed = Number(new Date(this.startAt)) - Date.now() + this.timeDiff;
        const isJustStarted = timePassed < 1000;

        if (isJustStarted) {
          this.setAnimation(CharacterAnimation.ROTATION, false).then(() => {
            this.setAnimation(CharacterAnimation.WAITING);
          });
        } else {
          this.setAnimation(CharacterAnimation.WAITING);
        }
      } else if (status === GameStatus.ENDED) {
        this.setAnimation(CharacterAnimation.FINISH, false).then(() => {
          this.setAnimation(CharacterAnimation.WAITING);
        });
      }
    },

    setAnimation(animationName, loop = true) {
      this.clearPendingAnimation();

      this.loop = loop;
      this.animationName = animationName;

      // 返回 Promise 来代替原 RxJS 的 Observable 完成监听
      return new Promise((resolve) => {
        this.animationResolve = (completedAnimation) => {
          if (completedAnimation === animationName) {
            resolve(completedAnimation);
          }
        };
      });
    },

    clearPendingAnimation() {
      this.animationResolve = null;
    },

    onAnimationComplete(animationName) {
      if (typeof this.animationResolve === 'function') {
        const resolve = this.animationResolve;
        this.animationResolve = null;
        resolve(animationName);
      }
    }
  }
};
